if (!customElements.get("custom-rating")) {
  class CustomRating extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.avgRating = this.calculateAverageRating() ?? 0;
      this.generateStarsMarkup();
    }

    // Use arrays that hold rating.value + rating_count for each bundle product
    calculateAverageRating() {
      this.ratingValues = this.dataset.ratingValues?.split(",").map(parseFloat);
      this.ratingCounts = this.dataset.ratingCounts?.split(",").map(Number);

      const { countTotal, reviewTotal } = this.ratingCounts.reduce(
        (totals, count, index) => {
          const rating = this.ratingValues[index];
          totals.countTotal += count;
          totals.reviewTotal += rating * count;
          return totals;
        },
        { countTotal: 0, reviewTotal: 0 }
      );

      this.countTotal = countTotal;

      return (reviewTotal / countTotal).toFixed(1);
    }

    generateStarsMarkup() {
      const innerDiv = document.createElement("div");
      innerDiv.className = "jdgm-prev-badge";

      const starsSpan = document.createElement("span");
      starsSpan.className = "jdgm-prev-badge__stars";
      starsSpan.style.marginRight = "4px";
      starsSpan.tabIndex = 0;
      starsSpan.setAttribute("aria-label", `'${this.avgRating} stars'`);
      starsSpan.setAttribute("role", "button");

      for (let i = 0; i < 5; i++) {
        const star = document.createElement("span");
        if (i < Math.floor(this.avgRating)) {
          star.className = "jdgm-star jdgm--on";
        } else if (
          i == Math.floor(this.avgRating) &&
          this.avgRating % 1 > 0.7
        ) {
          star.className = "jdgm-star jdgm--on";
        } else if (
          i == Math.floor(this.avgRating) &&
          this.avgRating % 1 > 0 &&
          this.avgRating % 1 <= 0.7
        ) {
          star.className = "jdgm-star jdgm--half";
        } else {
          star.className = "jdgm-star jdgm--off";
        }

        starsSpan.appendChild(star);
      }

      const ratingText = document.createElement("span");
      ratingText.className = "jdgm-prev-badge__text";
      ratingText.textContent = `${
        this.avgRating == "NaN" ? 0 : this.avgRating
      } ${this.dataset.from} ${this.countTotal} ${this.dataset.reviews}`;

      innerDiv.appendChild(starsSpan);
      innerDiv.appendChild(ratingText);

      this.appendChild(innerDiv);
    }
  }

  customElements.define("custom-rating", CustomRating);
}
